import $ from 'jquery'
import { baseUrl,timeout } from './env'
import { getToken } from './token'
import router from '../router'
import Loading from '../components/loading'

export function ajax(options){
  options = options || {}
  // 默认是 GET 请求
  options.methods = options.methods || 'GET'
  options.url = baseUrl + options.url || ''

  //默认同步请求 true为异步请求 异步请求同时请求多个api容易造成返回数据混乱
  options.async = options.async || true
  options.data = options.data || {}
  options.contentType = options.contentType || 'application/json;charset=UTF-8';
  options.success = options.success || function() {}
  options.error = options.error || function () {}
  options.token = getToken()

  options.xhrFields = options.xhrFields || null

  var xhr = $.ajax({
    headers:{
      'Content-Type':options.contentType,
      'oa-token':options.token
    },
    xhrFields: options.xhrFields,
    type:options.methods,
    dataType: "json",
    timeout: timeout,
    url:options.url,
    async:options.async,
    data:options.methods === "POST" ? JSON.stringify(options.data) : options.data,
    beforeSend: function (xhr) {
      // 数据加载成功之前，使用loading组件
      if (!options.noLoading) {
        Loading.hide()
        Loading.show()
      }
    },
    success:function(response){
      try{
        if(response.code == 403 || response.code == 401){
          const utype = window.sessionStorage.getItem('utype');
          window.sessionStorage.clear();
          const loginPath = utype === 'mer' ? '/merch/login' : '/';
          router.replace({path: loginPath});
        }else if(response.code == -1 && response.message && response.message.indexOf('token') !== -1){
          // token无效，根据用户类型跳转到对应登录页
          const utype = window.sessionStorage.getItem('utype');
          window.sessionStorage.clear();
          const loginPath = utype === 'mer' ? '/merch/login' : '/';
          router.replace({path: loginPath});
        }else{
          options.success(response)
        }
      }catch(e){
        Loading.hide()
      }finally{
        Loading.hide()
      }
    },

    error: function (textStatus) {
      try{
        if(textStatus.status == 600){
          alert("请联系管理员授权")
        }
        if(textStatus.status == 403 || textStatus.status == 401){
          window.sessionStorage.clear();
          router.replace({path:"/"});
        }else{
          options.error(textStatus)
        }
      }catch(e){
        Loading.hide()
      }finally{
        Loading.hide()
      }
    },
    complete:function(XMLHttpRequest,status){
      try{
        if(status == 'timeout') {
            xhr.abort(); // 超时后中断请求
        }
      }catch(e){
        Loading.hide()
      }finally{
        Loading.hide()
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/config/jQueryAjax.js